import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import { frontendURL } from '../../../../helper/URLHelper';

const BrainAssistantsIndex = () => import('./BrainAssistantsIndex.vue');
const BrainAssistantPage = () => import('./BrainAssistantPage.vue');
const BrainKnowledgeBasesIndex = () => import('./BrainKnowledgeBasesIndex.vue');
const BrainKnowledgeBasePage = () => import('./BrainKnowledgeBasePage.vue');
const StepIdentity = () => import('./steps/StepIdentity.vue');
const StepKnowledge = () => import('./steps/StepKnowledge.vue');
const StepConnect = () => import('./steps/StepConnect.vue');
const StepActivation = () => import('./steps/StepActivation.vue');
const StepPrompt = () => import('./steps/StepPrompt.vue');
const StepTools = () => import('./steps/StepTools.vue');
const StepFlow = () => import('./steps/StepFlow.vue');
const StepPlayground = () => import('./steps/StepPlayground.vue');
const InsightsPage = () => import('./InsightsPage.vue');
const CopilotPage = () => import('./CopilotPage.vue');

const meta = {
  permissions: ['administrator', 'agent'],
  featureFlag: FEATURE_FLAGS.CAPTAIN_V2,
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

export const brainRoutes = [
  {
    path: frontendURL('accounts/:accountId/captain/brain'),
    component: BrainAssistantsIndex,
    name: 'brain_assistants_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/captain/brain/copilot'),
    component: CopilotPage,
    name: 'brain_copilot',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/captain/brain/insights'),
    component: InsightsPage,
    name: 'brain_insights',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/captain/brain/knowledge-bases'),
    component: BrainKnowledgeBasesIndex,
    name: 'brain_knowledge_bases_index',
    meta,
  },
  {
    path: frontendURL(
      'accounts/:accountId/captain/brain/knowledge-bases/:knowledgeBaseId'
    ),
    component: BrainKnowledgeBasePage,
    name: 'brain_knowledge_base_show',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/captain/brain/:assistantId'),
    component: BrainAssistantPage,
    redirect: to => ({
      name: 'brain_wizard_identity',
      params: to.params,
    }),
    children: [
      {
        path: 'identity',
        component: StepIdentity,
        name: 'brain_wizard_identity',
        meta,
      },
      {
        path: 'prompt',
        component: StepPrompt,
        name: 'brain_wizard_prompt',
        meta,
      },
      {
        path: 'tools',
        component: StepTools,
        name: 'brain_wizard_tools',
        meta,
      },
      {
        path: 'flow',
        component: StepFlow,
        name: 'brain_wizard_flow',
        meta,
      },
      {
        path: 'knowledge',
        component: StepKnowledge,
        name: 'brain_wizard_knowledge',
        meta,
      },
      {
        path: 'connect',
        component: StepConnect,
        name: 'brain_wizard_connect',
        meta,
      },
      {
        path: 'activation',
        component: StepActivation,
        name: 'brain_wizard_activation',
        meta,
      },
      {
        path: 'playground',
        component: StepPlayground,
        name: 'brain_wizard_playground',
        meta,
      },
      // Legacy redirects so old bookmarks/links still work:
      {
        path: 'scripts',
        redirect: to => ({ name: 'brain_wizard_flow', params: to.params }),
      },
      {
        path: 'skills',
        redirect: to => ({ name: 'brain_wizard_tools', params: to.params }),
      },
      {
        path: 'messages',
        redirect: to => ({
          name: 'brain_wizard_activation',
          params: to.params,
        }),
      },
      {
        path: 'model',
        redirect: to => ({ name: 'brain_wizard_identity', params: to.params }),
      },
    ],
  },
];
